import axios from 'axios';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const selectEmpresa = this.element.querySelector('#gestion_economica_servicio_empresa_id');
    const selectSerie = this.element.querySelector('#gestion_economica_servicio_serie_id');

    selectEmpresa.addEventListener('change', () => {
      const params = {
        origen: 'manual',
        empresa_id: selectEmpresa.value,
      };

      axios.get('/gestion_economica/servicios/get_series', { params }).then((result) => {
        const { data } = result;
        // Limpiamos el select
        while (selectSerie.options.length) {
          selectSerie.remove(0);
        }
        data.forEach((serie) => {
          selectSerie.add(new Option(`${serie.nombre} ${serie.patron}`, serie.id));
        });
      });
    });
  }
}
